import { Link } from "react-router-dom";
import { ArrowRight, CircleCheck, Facebook, Instagram, Youtube } from "lucide-react";
import { APP_ROUTES } from "../../routes/AppRoutes";
import heroCutout from "../../assets/images/whatwedo/aiContentCreation/aiContentCreation.png";

// Same layout as the Events & Experiences hero (.ee-hero-* in eventsExperiences.css).
const POINTS = [
  "You approve the script and storyboard before any production starts",
  "Final files in 16:9, 9:16, 1:1 and 4:5 for YouTube, Reels, feeds and posters",
  "Hindi, English and regional-language versions of the same video",
];

const SOCIALS = [
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61571039155522" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/hkiofficial" },
  { icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@Hki_music" },
];

const AiHero = () => (
  <section className="ee-hero">
    {/* Themed backdrop, colour blob, outlined word and editor cutout. */}
    <div className="ee-hero-visual" aria-hidden="true">
      <div className="ee-hero-bg" />
      <div className="ee-hero-blob" />
      <span className="ee-hero-word">Content</span>
      <img className="ee-hero-cutout" src={heroCutout} alt="" />
    </div>

    <div className="ee-hero-card" data-aos="fade-right" data-aos-once="true">
      <span className="ee-hero-card-kicker">AI Content Creation</span>
      <h1 className="ee-hero-card-title">
        Made with AI. <span>Directed by people.</span>
      </h1>
      <p className="ee-hero-card-lead">Brand videos, reels, films and visuals. One brief in, every video out.</p>
      <p className="ee-hero-card-desc">
        Tell us your product, audience and goal. We script, generate, edit and deliver, in the formats and languages
        you need, ready to publish.
      </p>
      <ul className="ee-checks">
        {POINTS.map((point) => (
          <li key={point}>
            <CircleCheck size={16} /> {point}
          </li>
        ))}
      </ul>
      <Link to={APP_ROUTES.CONTACT_US} className="ee-btn">
        Contact Us <ArrowRight size={16} />
      </Link>
    </div>

    <div className="ee-hero-bar">
      <div className="ee-hero-socials">
        {SOCIALS.map(({ icon: Icon, label, href }) => (
          <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}>
            <Icon size={16} />
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default AiHero;
